<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    <Breadcrumb :links="breadCrumbData" />

    <div class="carrusel">
      <Carrusel />
    </div>

    <div class="container">
      <b-row>
        <b-col cols="12">
          <Button />
        </b-col>
      </b-row>

      <div v-if="permiso">
        <Visualizar />
        <b-row>
          <b-col class="one">
            <Help
              :title="title"
              :text="text"
              :text_Two="text_Two"
              :text_One="text_One"
              :text_three="text_three"
            />
          </b-col>
          <b-col class="btn-direction-flex">
            <b-button
              pill
              variant="primary"
              class="btn-one"
              @click="guardarBorrador"
              v-if="userPermissions"
            >
              Guardar como borrador
            </b-button>
            <b-button
              pill
              variant="primary"
              class="btn-two"
              @click="guardarFinalizado"
              v-if="userPermission"
            >
              Guardar y finalizar
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="title">
            <h5>
              Resultado de la Gestión - Resultados de los Productos Estratégicos
            </h5>
          </b-col>
        </b-row>

        <b-row v-if="userPermissions">
          <b-form-checkbox
            style="display:flex;   
        justify-content: flex-end; "
            v-model="checked"
            name="check-button"
            switch
          >
            <span class="span" v-if="checked"> No Aplica</span>
            <span class="span" v-else>No Aplica</span>
          </b-form-checkbox>
        </b-row>

        <div>
          <CkEditorText
            v-if="!checked"
            :modifyContent="modifyContent"
            :borrador="borrador"
          />
        </div>

        <AlertError v-if="checked" />
      </div>

      <div v-else>
        <div v-if="checked">
          <AlertError />
        </div>
        <div v-else>
          <NotPermision :contenido="contenido" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "../../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
// import Main from "./main/Main.vue";
import CkEditorText from "../../../../components/private/CkEditorText.vue";
import NotPermision from "@/components/private/TextNotPermisionPrueba.vue";
import Button from "./main/Button.vue";
import Visualizar from "@/components/button/escritorio/Visualizar.vue";
import { mapState } from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import Carrusel from "../../../../components/private/Carrusel.vue";
import { showAlert } from "../../../../components/tools/utils";
import AlertError from "../../../../components/error/AlertError.vue";
import Help from "../../../../components/tools/Modal";
export default {
  components: {
    Title,
    Breadcrumb,
    // Main,
    CkEditorText,
    NotPermision,
    Button,
    Visualizar,
    Carrusel,
    AlertError,
    Help,
  },
  data() {
    return {
      permiso: false,
      breadCrumbData: null,
      content: "",
      nombre: "avance_gestion",
      borrador: "",
      contenido: null,
      checked: false,
      userPermissions: true,
      userPermission: true,

      buttonViews: false,
      dataViews: null,
      datosUser: null,
      title: "Resultados de productos estratégicos",
      text:
        "Presentar los resultados (logros y no logros) de la gestión de la institución en términos de la provisión de sus productos estratégicos a los usuarios, beneficiarios y/o ciudadanos, así como aspectos que sean de interés para la ciudadanía en el marco de la función que le compete al Servicio.",
      text_Two:
        "Para la presentación de cada resultado relevante (logros y no logros), se deberá presentar primero el producto estratégico (o programa si corresponde) sobre el que se dará cuenta pública, descrito brevemente. Luego se deberá realizar un análisis cuantitativo y cualitativo, el que puede apoyarse con gráficos y tablas auto-explicativas. ",

      text_One:
        "Se entiende por logros las acciones desarrolladas que tuvieron resultados satisfactorios, que pueden expresarse de manera cuantitativa o cualitativa. ",
      text_three:
        "Por otro lado, se entiende por no logros a las acciones desarrolladas por la institución que tuvieron resultados no satisfactorios, es decir, no se cumplieron los compromisos, metas o la programación definida para la institución. En este caso se solicita explicar las causas de dicha situación precisando si éstas se deben a factores internos o externos a la gestión de la institución. En los casos que corresponda y sea factible, informar las medidas que se están adoptando para mejorar los resultados obtenidos.",
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name:
            "Resultados de Gestión - Resultados de los Productos Estratégicos",
          routeName: "programaGobierno",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
    modifyContent: function(text) {
      this.content = text;
    },
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        data: {
          content: this.content,
          aplica: this.checked,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      try {
        const toSend = this.buildData("borrador");

        await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              content: this.content,
              aplica: this.checked,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
      }
    },
    guardarFinalizado: async function() {
      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar el documento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const toSend = this.buildData("finalizado");

            await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardando documento",
              timerProgressBar: true,
              timer: 3000,
            });
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  content: this.content,
                  aplica: this.checked,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );
              showAlert({
                icon: "success",
                text: "Documento Guardado ",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerBorrador: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: this.nombre,
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        this.checked = res.data.info.aplica;

        console.log("Checked", this.checked);

        console.log(res.data.info.aplica);
        if (res.data.info.content) {
          this.borrador = this.contenido = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      console.log(relacionUs);
      if (
        relacionUs.permisos.find((p) => p.permisoId === 4) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 5 ||
        relacionUs.rolId === 4
      ) {
        this.permiso = true;
      }
    },
    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const data = JSON.parse(localStorage.getItem("user"));
        const relacionUs = data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);

        //funcionario Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Jefe de Servicio BGI Borrador
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        }

        //Jefe de Servicio BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        }

        //Funcionario
        if (relacionUs.rolId === 5) {
          this.userPermission = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerBorrador();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerRevision();
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}

.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}
.title {
  margin-top: 20px;
  margin-bottom: 21px;
  text-align: center;
  color: #052333;
}

.span {
  font-size: 18px;
  color: #052333;
  font-weight: 600;
}

@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
